import React, { useEffect, useState } from 'react';
import Menu from '../../comum/Menu';
import Footer from '../../comum/Footer';
import { api } from '../../services/api';
import Swal from 'sweetalert2';
import './ouvidoria.css'; // ou crie um novo ouvidoria.css para customizar

const Ouvidoria = () => {
    const chapaLocal = localStorage.getItem('chapa');
    const lojaLocal = localStorage.getItem('loja');
    const [tipos, setTipos] = useState([]);
    const [setores, setSetores] = useState([]);
    const [pontuacoes, setPontuacoes] = useState([]);

    const [tipoSelecionado, setTipoSelecionado] = useState('');
    const [setorSelecionado, setSetorSelecionado] = useState('');
    const [pontoSelecionado, setPontoSelecionado] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [identificado, setIdentificado] = useState(true);

    useEffect(() => {
        const carregarDados = async () => {
            try {
                const res = await api.get('/usuario/ouvidoria/listar');
                setTipos(res.data.tipo.map(t => t.valor2));
                setSetores(res.data.setor.map(s => s.valor2));
                setPontuacoes(res.data.ponto.map(p => p.valor2));
            } catch (err) {
                console.error('Erro ao carregar ouvidoria:', err);
                Swal.fire('Erro', 'Não foi possível carregar os dados da ouvidoria.', 'error');
            }
        };
        carregarDados();
    }, []);

    const enviarOuvidoria = async () => {
        if (!tipoSelecionado || !setorSelecionado || !pontoSelecionado || !mensagem) {
            Swal.fire('Atenção', 'Preencha todos os campos obrigatórios.', 'warning');
            return;
        }

        const payload = {
            chapa: identificado ? chapaLocal : '',
            tipo: tipoSelecionado,
            loja: lojaLocal,
            setor: setorSelecionado,
            ponto: pontoSelecionado,
            mensagem
        };

        try {
            await api.post('/usuario/ouvidoria', payload);
            Swal.fire('Enviado', 'Ouvidoria registrada com sucesso.', 'success');
            setTipoSelecionado('');
            setSetorSelecionado('');
            setPontoSelecionado('');
            setMensagem('');
        } catch (err) {
            console.error('Erro ao enviar ouvidoria:', err);
            Swal.fire('Erro', 'Erro ao registrar a ouvidoria.', 'error');
        }
    };

    return (
        <div>
            <Menu modulo="ARBOR" />
            <div className="container mt-4">
                <h3 className="text-danger">Ouvidoria</h3>

                {/* Tipo */}
                <div className="mt-3">
                    <div className="card text-white bg-success mb-3">
                        <div className="card-body">
                            <h4 className="text-center text-white">Ouvidoria</h4>
                        </div>
                    </div>
                    <label className="form-label fw-bold text-danger">Tipo da ouvidoria</label>
                    <div className="d-flex flex-wrap gap-3">
                        {tipos.map((tipo, idx) => (
                            <div key={idx}>
                                <input
                                    type="radio"
                                    id={`tipo-${idx}`}
                                    name="tipo"
                                    value={tipo}
                                    checked={tipoSelecionado === tipo}
                                    onChange={() => setTipoSelecionado(tipo)}
                                />
                                <label htmlFor={`tipo-${idx}`} className="ms-1">{tipo}</label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Setor */}
                <div className="mt-4">
                    <label className="form-label fw-bold text-danger">Quero falar sobre</label>
                    <div className="d-flex flex-wrap gap-3">
                        {setores.map((setor, idx) => (
                            <div key={idx}>
                                <input
                                    type="radio"
                                    id={`setor-${idx}`}
                                    name="setor"
                                    value={setor}
                                    checked={setorSelecionado === setor}
                                    onChange={() => setSetorSelecionado(setor)}
                                />
                                <label htmlFor={`setor-${idx}`} className="ms-1">{setor}</label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Pontuação */}
                <div className="mt-4">
                    <label className="form-label fw-bold text-danger">Pontuação</label>
                    <div className="d-flex flex-wrap gap-4">
                        {pontuacoes.map((ponto, idx) => (
                            <div key={idx}>
                                <input
                                    type="radio"
                                    id={`ponto-${idx}`}
                                    name="ponto"
                                    value={ponto}
                                    checked={pontoSelecionado === ponto}
                                    onChange={() => setPontoSelecionado(ponto)}
                                />
                                <label htmlFor={`ponto-${idx}`} className="ms-1">{ponto}</label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Mensagem */}
                <div className="mt-4">
                    <label className="form-label fw-bold text-danger">Mensagem</label>
                    <textarea
                        className="form-control"
                        rows={4}
                        value={mensagem}
                        onChange={(e) => setMensagem(e.target.value)}
                        placeholder="Digite sua mensagem aqui..."
                    ></textarea>
                </div>

                {/* Identificação */}
                <div className="form-check mt-3">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="identificado"
                        checked={identificado}
                        onChange={() => setIdentificado(!identificado)}
                    />
                    <label className="form-check-label text-danger" htmlFor="identificado">
                        Me identificar
                    </label>
                </div>

                {/* Botões */}
                <div className="d-flex justify-content-end mt-4 gap-2">
                    <button className="btn btn-success" onClick={enviarOuvidoria}>Salvar</button>
                    <button className="btn btn-danger" onClick={() => window.history.back()}>Cancelar</button>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Ouvidoria;
